<template>
  <Head title="Playbooks - List" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col"> 
          <playbook-landing></playbook-landing>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';
import { usePlaybookStore } from '../../stores/playbook';
import { useClientStore } from '../../stores/client';

const props = defineProps({
  client: Object,
  playbook_types: Array,
  playbooks: Array
});

// Set window globals immediately for legacy component compatibility
window.__CLIENT__ = props.client;
window.__PLAYBOOK__ = {
  playbook_types: props.playbook_types,
  playbooks: props.playbooks
};

// Also initialize stores directly
const playbookStore = usePlaybookStore();
const clientStore = useClientStore();

clientStore.setClient(props.client);
playbookStore.initialize(window.__PLAYBOOK__);
</script>

